import {Card, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import {IconIllustration} from 'presentation/components';
import {StyledIconButton} from './styles';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {useNavigate} from 'react-router-dom';
import {FacialBiometricEnum} from 'presentation/constants';
import {FacialBiometricsTaggingEnum} from 'main/analytics/gaTagsEnum';

const {facialBiometric} = translations['pt-br'].commons;
const {description} = translations['pt-br'].privateFlow.profile.facialBiometric;

export function FacialBiometricsField() {
	const {palette} = useTheme();
	const navigate = useNavigate();

	const handleNavToRegisterFacialBiometrics = () => {
		navigate(FacialBiometricEnum.FACIAL_BIOMETRIC);
	};

	return (
		<Card
			elevation={0}
			sx={{p: 2}}
			onClick={handleNavToRegisterFacialBiometrics}
			data-tag-id={FacialBiometricsTaggingEnum.CLICK_CADASTRAR_BIOMETRIA_FACIAL_PERFIL}>
			<Stack direction="row" spacing={2} alignItems="center" width="100%">
				<IconIllustration
					variant="primary"
					customIconName="facial-recognition"
					size="smaller"
				/>
				<Stack>
					<Typography variant="body2">{facialBiometric}</Typography>
					<Typography variant="body2" color="textSecondary">
						{description}
					</Typography>
				</Stack>
				<StyledIconButton
					aria-label="navigate"
					onClick={handleNavToRegisterFacialBiometrics}>
					<Icon name="arrow-right-filled" size={20} color={palette.primary.main} />
				</StyledIconButton>
			</Stack>
		</Card>
	);
}
